<template>
  <KeepAlive v-if="data?.type === 'category'">
    <ContainerCategoryContent :category="data?.payload" />
  </KeepAlive>
  <ContainerProductWrapper v-else-if="data?.type === 'product'" :product="data?.payload" />
</template>

<script setup lang="ts">
definePageMeta({
  /**
   * Prevents re-rendering if the path is a variant of a product
   */
  key: route => {
    const parts = route.params.slug as string[];

    // is variant path
    if (parts.includes('var') || parts.length === 1) {
      return parts[0];
    }

    if (parts.length > 1) {
      return parts[parts.length - 1];
    }

    return route.fullPath;
  },
});
/**
 * A Helper Method that extracts the slug parameter from the url
 */
const extractSlugFromUrl = (parts: string[]) => {
  if (!parts.length) return '';
  // check if it contains var
  if (parts.includes('var')) {
    return parts.at(0);
  }

  return parts.at(parts.length - 1);
};

const route = useRoute();

const appFetchProductBySlug = useAppFetchProductBySlug();

const data = await useResolveSlugParameter(
  extractSlugFromUrl(route.params.slug as string[]) || '',
  appFetchProductBySlug,
);
</script>
